import { motion } from 'framer-motion';
import React from 'react';

interface CardProps {
  children: React.ReactNode;
}

export const FadeSlideMotionBox = (props: CardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, height: 0, overflow: 'hidden' }}
      transition={{
        duration: 0.2,
      }}
      style={{ overflow: 'visible' }}
    >
      {props.children}
    </motion.div>
  );
};
